import {
  AirplaneTiltIcon as BaseAirplaneTiltIcon,
  AirplaneTakeoffIcon as BaseAirplaneTakeoffIcon,
  AirplaneLandingIcon as BaseAirplaneLandingIcon,
  CaretLeftIcon as BaseCaretLeftIcon,
  CaretRightIcon as BaseCaretRightIcon,
  ArrowRightIcon as BaseArrowRightIcon,
} from "@phosphor-icons/react";

import { addRtlSupport } from "./utils/addRtlSupport";

export const AirplaneTiltIcon = addRtlSupport(BaseAirplaneTiltIcon);
export const AirplaneTakeoffIcon = addRtlSupport(BaseAirplaneTakeoffIcon);
export const AirplaneLandingIcon = addRtlSupport(BaseAirplaneLandingIcon);
export const ArrowRightIcon = addRtlSupport(BaseArrowRightIcon);
export const CaretLeftIcon = addRtlSupport(BaseCaretLeftIcon);
export const CaretRightIcon = addRtlSupport(BaseCaretRightIcon);
